// pages/LoadingPage.tsx
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
// import { getDate } from "../util";
import { useKakaoStore } from "../store/useKakao";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function LoadingPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code"); // URL 파라미터에서 code 추출
  const navigate = useNavigate();

  const { setKakaoUser, kakaoUser, postData } = useKakaoStore();
  const [showLoading, setShowLoading] = useState<boolean>(false);

  const trkId = localStorage.getItem("trkId");

  useEffect(() => {
    handleKakaoAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 2초 후에 로딩창 표시 로직
  useEffect(() => {
    if (!kakaoUser || !postData) {
      const timer = setTimeout(() => {
        setShowLoading(true);
      }, 2000);
      return () => clearTimeout(timer);
    } else {
      // 데이터가 모두 준비되면 로딩창을 숨김
      setShowLoading(false);
    }
  }, [kakaoUser, postData]);

  // 인가코드(code)가 있으면 토큰/유저정보를 받고, 10초 후 결과 페이지로 이동
  const handleKakaoAuth = async () => {
    if (!code) {
      // code가 없으면 메인 페이지로
      navigate("/");
      return;
    }

    try {
      // 인가 코드 교환은 비밀 키가 노출되지 않도록 백엔드에서 처리한다.
      const userInfo = await requestKakaoUser(code);
      const userInfoWithTrkId = { ...userInfo, trkId };

      setKakaoUser(userInfoWithTrkId);
    } catch (error) {
      console.error("카카오 인증 처리 중 오류 발생:", error);
      navigate("/");
    }
  };

  useEffect(() => {
    if (kakaoUser && postData) {
      navigate("/result");
    }
  });

  const requestKakaoUser = async (authorizationCode: string) => {
    const response = await fetch(`${BASE_URL}/user/oauth/kakao`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code: authorizationCode }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  };

  // const onClickAd = () => {
  //   window.open("https://saju.dbcart.net/?g=today", "_blank");
  //   navigate("/result");
  // };

  if ((!kakaoUser || !postData) && !showLoading) {
    return null;
  }

  return <div></div>;

  // return (
  //   <div className="main_container">
  //     <main style={{ height: "100vh", overflow: "hidden" }}>
  //       <div className="short_date">{getDate(1).short}</div>
  //       <div className="name_luck">
  //         {kakaoUser?.kakao_account.name}님의 내일 운세는?
  //       </div>
  //       <div className="question_img"></div>
  //       <div className="blur_wrapper">
  //         <div className="blur_cover"></div>
  //         <div className="all_luck_wrapper">
  //           <div className="all_luck_title">운세 총운</div>
  //           <div className="all_luck_content">
  //             읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용
  //             없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무
  //             소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도
  //             아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용
  //             없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무
  //             소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도
  //             아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용
  //             없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무
  //             소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도
  //             아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용
  //             없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무
  //             소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도
  //             아무 소용 없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용
  //             없지롱.읽어도 아무 소용 없지롱.읽어도 아무 소용 없지롱.
  //           </div>
  //         </div>
  //       </div>
  //       <div className="ad_wrapper">
  //         <div>다음 내용이 궁금하다면?</div>
  //         <div onClick={onClickAd}>내일의 운세 보러가기</div>
  //         <div>원치 않는 경우 뒤로 가기를 눌러주세요</div>
  //       </div>

  //       {/* 로딩 */}
  //       {showLoading && (
  //         <div className="result_loading">
  //           <div className="legend_backdrop">
  //             <div className="loading_img"></div>
  //             <div
  //               className="loading_text"
  //               style={{
  //                 fontWeight: 600,
  //                 fontSize: "18px",
  //                 marginBottom: "8px",
  //               }}
  //             >
  //               로그인 진행 중이에요 😊
  //             </div>
  //             <div
  //               className="loading_text"
  //               style={{ marginTop: "0px", fontWeight: 300 }}
  //             >
  //               접속자가 많을 경우 다소 시간이 걸릴 수 있어요
  //             </div>
  //             <div
  //               className="loading_text"
  //               style={{ marginTop: "0px", fontWeight: 300 }}
  //             >
  //               너무 오래 걸린다면 잠시 후 다시 시도해 주세요!
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </main>
  //   </div>
  // );
}

export default LoadingPage;
